import PayoutPrintPage from "./payoutPrint";

export default PayoutPrintPage;